import { GlSkeletonLoader } from '@gitlab/ui';
export default {
    name: 'ActivitySkeletonLoader',
    components: {
        GlSkeletonLoader
    },
    props: {
        count: {
            type: Number,
            required: false,
            default: 3
        }
    }
};
